import React from "react";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import MenuIcon from "@mui/icons-material/Menu";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LanguageIcon from "@mui/icons-material/Language";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AssessmentIcon from "@mui/icons-material/Assessment";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PaymentsIcon from "@mui/icons-material/Payments";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import SettingsIcon from "@mui/icons-material/Settings";
import ListAltIcon from "@mui/icons-material/ListAlt";
import SummarizeIcon from "@mui/icons-material/Summarize";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import WaterDamageOutlinedIcon from "@mui/icons-material/WaterDamageOutlined";
import AtmIcon from "@mui/icons-material/Atm";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import ViewSidebarTwoToneIcon from "@mui/icons-material/ViewSidebar";
import ViewHeadlineRoundedIcon from "@mui/icons-material/ViewHeadlineRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AddRoundedIcon from "@mui/icons-material/AddRounded";

type Props = {
  name: string;
  className?: string;
  fontSize?: SvgIconProps["fontSize"];
  color?: SvgIconProps["color"];
};

const iconMap = {
  menu: MenuIcon,
  more: MoreHorizIcon,
  viewSidebar: ViewSidebarTwoToneIcon,
  user: PersonOutlineIcon,
  language: LanguageIcon,
  home: HomeOutlinedIcon,
  dashboard: DashboardIcon,
  account: AccountCircleIcon,
  report: AssessmentIcon,
  recharge: LocalAtmIcon,
  bkash: AccountBalanceWalletIcon,
  upay: PaymentsIcon,
  water: WaterDropIcon,
  card: CreditCardIcon,
  setting: SettingsIcon,
  log: ListAltIcon,
  report2: SummarizeIcon,
  zone: FmdGoodOutlinedIcon,
  vendor: BusinessCenterOutlinedIcon,
  pump: WaterDamageOutlinedIcon,
  atm: AtmIcon,
  cost: ShowChartIcon,
  userManage: ManageAccountsOutlinedIcon,
  pane: ViewHeadlineRoundedIcon,
  chevronDown: ExpandMoreIcon,
  arrowRight: ArrowForwardIcon,
  add: AddRoundedIcon,
};

const fallbackIcon = DashboardIcon;

function Icon({ name, className, fontSize = "small", color }: Props) {
  const Component = iconMap[name as keyof typeof iconMap] ?? fallbackIcon;
  return <Component className={className} fontSize={fontSize} color={color} />;
}

export default Icon;
